@if (enabled() && updateAvailable()) {
  <div class="app-update-banner" role="status" aria-live="polite">
    <p class="app-update-banner__text app-type-small app-tone-text-inverse">
      A new version of Momentum is available.
    </p>
    <button
      type="button"
      class="app-update-banner__reload app-btn app-btn--primary app-btn--compact"
      (click)="reload()"
    >
      Reload
    </button>
  </div>
}
